import InviteListingViewer from './InviteListingViewer.component';

export default InviteListingViewer;
